module.exports = "<div [innerHtml]=\"setAgreementText(agreementText)\"></div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/agreement-modal/agreement-modal.component.html
// module id = ./src/app/shared/components/agreement-modal/agreement-modal.component.html
// module chunks = main